// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar CSS */
.sidebar {
  width: 250px; /* Default width for desktop */
  flex-shrink: 0;
  background-color: #1e1e1e; /* Darker background color */
  height: 100vh;

  color: #fff;
  
  transition: width 0.3s;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
  
}

.sidebar .logo {
  text-align: center;
  padding: 20px;
  background-color: #34495e; /* Slightly different dark color for the logo area */
}

.logo img {
  max-width: 100%;
  height: auto;
}

.sidebar-item {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  transition: background-color 0.15s;
  border-radius: 5px;
  cursor: pointer;
  font-size: 15px;
  color: #ffffff; /* Light gray color for text */
}

.sidebar-item:hover {
  background-color: rgba(145, 132, 132, 0.1);
  color: #fff; /* Change text color on hover */
}


.sidebar-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-content {
  padding-left: 10px;
}

.sidebar-item.plain {
  text-decoration: none;
  color: inherit; /* Inherit color from parent */
  display: flex;
  align-items: center;
}




/* Hamburger Icon for Mobile */
.hamburger-icon {
  position: absolute;
  top: 10px; /* Adjust the distance from the top */
  right: 25px; /* Adjust the distance from the right */
  cursor: pointer;
  display: none; /* Hidden by default */
}

.hamburger-icon img {
  width: 35px; /* Adjust width as needed */
  height: 35px; /* Adjust height as needed */
}

/* Media query for mobile devices */
@media screen and (max-width: 768px) {
  .sidebar {
    width: 200px; /* Adjusted width for mobile */
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .hamburger-icon {
    display: block;
  }

  .sidebar-item {
    padding: 10px 15px; /* Adjusted padding for mobile */
  }
}

/* Optional: Add styles for icons */
.sidebar-item i {
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/Sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,YAAY,EAAE,8BAA8B;EAC5C,cAAc;EACd,yBAAyB,EAAE,4BAA4B;EACvD,aAAa;;EAEb,WAAW;;EAEX,sBAAsB;EACtB,wCAAwC;;AAE1C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB,EAAE,oDAAoD;AACjF;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,0CAA0C;EAC1C,WAAW,EAAE,+BAA+B;AAC9C;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc,EAAE,8BAA8B;EAC9C,aAAa;EACb,mBAAmB;AACrB;;;;;AAKA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,SAAS,EAAE,qCAAqC;EAChD,WAAW,EAAE,uCAAuC;EACpD,eAAe;EACf,aAAa,EAAE,sBAAsB;AACvC;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,YAAY,EAAE,4BAA4B;AAC5C;;AAEA,mCAAmC;AACnC;EACE;IACE,YAAY,EAAE,8BAA8B;IAC5C,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB,EAAE,gCAAgC;EACtD;AACF;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB","sourcesContent":["/* Sidebar CSS */\r\n.sidebar {\r\n  width: 250px; /* Default width for desktop */\r\n  flex-shrink: 0;\r\n  background-color: #1e1e1e; /* Darker background color */\r\n  height: 100vh;\r\n\r\n  color: #fff;\r\n  \r\n  transition: width 0.3s;\r\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);\r\n  \r\n}\r\n\r\n.sidebar .logo {\r\n  text-align: center;\r\n  padding: 20px;\r\n  background-color: #34495e; /* Slightly different dark color for the logo area */\r\n}\r\n\r\n.logo img {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.sidebar-item {\r\n  padding: 10px 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: background-color 0.15s;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  color: #ffffff; /* Light gray color for text */\r\n}\r\n\r\n.sidebar-item:hover {\r\n  background-color: rgba(145, 132, 132, 0.1);\r\n  color: #fff; /* Change text color on hover */\r\n}\r\n\r\n\r\n.sidebar-title {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.sidebar-content {\r\n  padding-left: 10px;\r\n}\r\n\r\n.sidebar-item.plain {\r\n  text-decoration: none;\r\n  color: inherit; /* Inherit color from parent */\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n\r\n\r\n\r\n/* Hamburger Icon for Mobile */\r\n.hamburger-icon {\r\n  position: absolute;\r\n  top: 10px; /* Adjust the distance from the top */\r\n  right: 25px; /* Adjust the distance from the right */\r\n  cursor: pointer;\r\n  display: none; /* Hidden by default */\r\n}\r\n\r\n.hamburger-icon img {\r\n  width: 35px; /* Adjust width as needed */\r\n  height: 35px; /* Adjust height as needed */\r\n}\r\n\r\n/* Media query for mobile devices */\r\n@media screen and (max-width: 768px) {\r\n  .sidebar {\r\n    width: 200px; /* Adjusted width for mobile */\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 1000;\r\n    transform: translateX(-100%);\r\n    transition: transform 0.3s ease;\r\n  }\r\n\r\n  .sidebar.open {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .hamburger-icon {\r\n    display: block;\r\n  }\r\n\r\n  .sidebar-item {\r\n    padding: 10px 15px; /* Adjusted padding for mobile */\r\n  }\r\n}\r\n\r\n/* Optional: Add styles for icons */\r\n.sidebar-item i {\r\n  margin-right: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
